import { useEffect, useState } from "react";
import { Eye, ShoppingBag, Flame } from "lucide-react";

// A small "live" strip that cycles through real-time social-proof stats.
// Always visible (good for mobile) and auto-rotates every few seconds.
export const LiveActivity = ({ product, className = "" }) => {
  const views = product?.views_24h || 0;
  const bags = product?.basket_count || 0;
  const sold = product?.sold_count || 0;

  const stats = [];
  if (views > 0) stats.push({ icon: Eye, text: `${views} ${views === 1 ? "person" : "people"} viewed this in the last 24h` });
  if (bags > 0) stats.push({ icon: ShoppingBag, text: `In ${bags} shopping ${bags === 1 ? "bag" : "bags"} right now` });
  if (sold > 0) stats.push({ icon: Flame, text: `${sold} sold recently` });

  const [idx, setIdx] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (stats.length <= 1) return;
    const t = setInterval(() => {
      setShow(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % stats.length);
        setShow(true);
      }, 250);
    }, 3200);
    return () => clearInterval(t);
  }, [stats.length]);

  if (stats.length === 0) return null;
  const { icon: Icon, text } = stats[idx % stats.length];

  return (
    <div
      data-testid="live-activity"
      className={`flex items-center gap-2 font-clean min-h-[1.5rem] ${className}`}
    >
      <span
        key={idx}
        className={`inline-flex items-center gap-1.5 text-sm text-gray-600 whitespace-nowrap transition-opacity duration-250 ${show ? "opacity-100" : "opacity-0"}`}
        data-testid="live-activity-text"
      >
        <Icon className="w-4 h-4 text-pink shrink-0" strokeWidth={2.1} />
        {text}
      </span>
    </div>
  );
};
